import { apiClientWithRefreshToken } from "@/api/apiClient";
import { ArProfile } from "@/v2/types";

export default async function FindArProfile(): Promise<ArProfile> {
    const res = await apiClientWithRefreshToken({
        url: `/ar-engineering-profile/`,
        method: "GET",
    });
    return res.data;
}
